export interface TaskReference {
  taskNumber: number;
  shipment?: { shipmentNumber?: number | null } | null;
  shipmentNumber?: number | null;
  shipmentSnapshot?: unknown;
}

/** Accept the carrier list, lookup and trip snapshot projections. */
export function taskReferenceParts(task: TaskReference): {
  shipment: string;
  task: string;
  primary: string;
  secondary: string;
} {
  const snapshot = task.shipmentSnapshot;
  const snapshotNumber =
    snapshot &&
    typeof snapshot === "object" &&
    "shipmentNumber" in snapshot &&
    typeof snapshot.shipmentNumber === "number"
      ? snapshot.shipmentNumber
      : undefined;
  const number = [
    task.shipment?.shipmentNumber,
    task.shipmentNumber,
    snapshotNumber,
  ].find(
    (candidate) =>
      typeof candidate === "number" &&
      Number.isInteger(candidate) &&
      candidate > 0
  );
  const shipment =
    number === undefined ? "Shipment reference unavailable" : `SHP-${number}`;
  const taskReference =
    task.taskNumber > 0
      ? `TSK-${task.taskNumber}`
      : "Task reference unavailable";
  return {
    shipment,
    task: taskReference,
    primary: number === undefined ? taskReference : shipment,
    secondary: number === undefined ? shipment : taskReference,
  };
}

export function taskLabel(task: TaskReference): string {
  const references = taskReferenceParts(task);
  return `${references.shipment} · ${references.task}`;
}
